import {AppBar} from "@material-ui/core";
import React, {useState, useEffect, useContext} from "react";
import HeaderComponent from "./HeaderComponent";
import makeStyles from "@material-ui/styles/makeStyles";
import clsx from "clsx";
import {useKeycloakFunctions} from "../../../hooks/useKeycloakFunctions";
import {MarketplaceConsentContext} from "../../../store/providers/MarketplaceConsentProvider";
import {useLocation} from "../../../common/common";
import TopNotificationBanner from "../../widget/banner/TopNotificationBanner";
import { IMPRINT } from "../../../common/routes";

const useStyles = makeStyles(theme => ({
    appBar: {
        background: theme.palette.secondary["50"]
    },
    appBarAdmin: {
        background: theme.palette.secondary["100"]
    }
}));

const Header = () => {
    const classes = useStyles();
    const {isAdmin} = useKeycloakFunctions();
    const {acceptedAlready} = useContext(MarketplaceConsentContext);
    const {location} = useLocation();
    const [openMarketPopover, setOpenMarketPopover] = useState(false);

    useEffect(() => {
        if (!isAdmin()) {
            if ((location?.pathname?.includes("/marketplace") && !location?.pathname?.includes(IMPRINT)) && acceptedAlready) {
                setOpenMarketPopover(true);
            }
        }

    }, [acceptedAlready]);

    return (
        <>
            <TopNotificationBanner />
            <AppBar
                position="static"
                color="secondary"
                className={clsx(classes.appBar, {[classes.appBarAdmin]: isAdmin()})}
                elevation={0}
            >
                <HeaderComponent
                    openPopover={openMarketPopover}
                />
            </AppBar>
        </>
    );
};

export default Header;
